import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  	allImages: null,
  	CSS: "",
  	flags: [null, null, null, null, null, null, null, null], // Adding 8 flags for now!
  	solvedQuestionsList: [],
  	styleElementCreated: false,
  	questionsList: null, // Contains the questions, tags and hints altogether...
  	captchaToken: null,
  	captchaSolved: false,
  	labStarted: false,
  	labURL: null,
  	cid: null, // For closing the lab!
  	level: 0, // Indicates where we are in our flag solving journey!
    challengeDescription: "",
    tabNames: ["attacker-1"],
    sequentialSolveState: true,
  },
  mutations: {
  	_addToFlags(context, _flagIndexPair) {
  		context.flags[_flagIndexPair["index"]] = _flagIndexPair["flag"];
  	},
  	_addToSolvedQuestion(context, _idx) {
  		context.solvedQuestionsList.push(_idx);
  	},
  	_saveAllImages(context, _images) {
  		context.allImages = _images;
  	},
    _setChallengeDescription(context, _desc) {
      context.challengeDescription = _desc;
    },
  	_setCSS(context, _css) {
  		context.CSS = _css;
  	},
  	_setLevel(context, _level) {
  		context.level = _level;
  	},
  	_setStyleElementCreationState(context, _state) {
  		context.styleElementCreated = _state;
  	},
  	_setQuestionsList(context, _list) {
  		context.questionsList = _list;
  	},
  	_setLabURL(context, _url) {
  		context.labURL = _url;
  	},
  	_setLabCID(context, _cid) {
  		context.cid = _cid;
  	},
  	_setCaptchaToken(context, _token) {
  		context.captchaToken = _token;
  	},
  	_setLabStartState(context, _state) {
  		context.labStarted = _state;
  	},
  	_resetCTFState(context) {
  		context.level = 0;
  		context.solvedQuestionsList = [];
  		context.flags = [null, null, null, null, null, null, null, null];
  	},
  	_resetState(context) {
      context.captchaToken = null;
      context.labURL = null;
      context.cid = null;
      context.captchaSolved = false;
      context.labStarted = false;
      context.tabNames = ["attacker-1"];
  	},
    _setTabName(context, _nameIndexPair) {
      context.tabNames[_nameIndexPair["index"]] = _nameIndexPair["name"];
    },
    _addToTabName(context, _name) {
      context.tabNames.push(_name);
    },
    _removeTabName(context, _index) {
      context.tabNames.splice(_index, 1);
    },
    _initTabNames(context) {
      context.tabNames = ["attacker-1"];
    },
  },
  actions: {
  	addToFlags(context, flagIndexPair) {
  		context.commit("_addToFlags", flagIndexPair);
  	},
  	addToSolvedQuestion(context, idx) {
  		context.commit("_addToSolvedQuestion", idx)
  	},
  	saveAllImages(context, images) {
  		context.commit("_saveAllImages", images);
  	},
    setChallengeDescription(context, desc) {
      context.commit("_setChallengeDescription", desc);
    },
  	setCSS(context, css) {
  		context.commit("_setCSS", css);
  	},
  	setLevel(context, level) {
  		context.commit("_setLevel", level);
  	},
  	setStyleElementCreationState(context, state) {
  		context.commit("_setStyleElementCreationState", state);
  	},
  	setQuestionsList(context, list) {
  		context.commit("_setQuestionsList", list);
  	},
  	setLabURL(context, url) {
		context.commit("_setLabURL", url);
  	},
  	setLabCID(context, cid) {
		context.commit("_setLabCID", cid);
  	},
  	setCaptchaToken(context, token) {
  		context.commit("_setCaptchaToken", token);
  	},
  	setLabStartState(context, state) {
  		context.commit("_setLabStartState", state);
  	},
  	resetCTFState(context) {
  		context.commit("_resetCTFState");
  	},
  	resetState(context) {
  		context.commit("_resetState");
  	},
    setTabName(context, nameIndexPair) {
      context.commit("_setTabName", nameIndexPair);
    },
    addToTabName(context, name) {
      context.commit("_addToTabName", name);
    },
    removeTabName(context, index) {
      context.commit("_removeTabName", index);
    },
    initTabNames(context) {
      context.commit("_initTabNames");
    },
    setSequentialSolveState(context, state) {
      context.commit("_setSequentialSolveState", state);
    },
  },
  getters: {
  	getAllImages(context) {
  		return context.allImages;
  	},
    getChallengeDescription(context) {
      return context.challengeDescription;
    },
  	getCSS(context) {
  		return context.CSS;
  	},
  	getFlags(context) {
  		return context.flags;
  	},
  	getLevel(context) {
  		return context.level;
  	},
  	getSolvedQuestionsList(context) {
  		return context.solvedQuestionsList;
  	},
  	isStyleElementCreated(context) {
  		return context.styleElementCreated;
  	},
  	getQuestionsList(context) {
  		return context.questionsList;
  	},
  	getLabURL(context) {
  		return context.labURL;
  	},
  	getLabCID(context) {
  		return context.cid;
  	},
  	getCaptchaToken(context) {
  		return context.captchaToken;
  	},
  	isLabStarted(context) {
  		return context.labStarted;
  	},
    areFlagsToBeSolvedSequentially(context) {
      return context.sequentialSolveState;
    },
    getTabNames(context) {
      return context.tabNames;
    },
  },
  modules: {},
  plugins: [
	createPersistedState({
		storage: {
			getItem: key => ls.get(key),
			setItem: (key, value) => ls.set(key, value),
			removeItem: key => ls.remove(key)
		}
	})
  ]
});
